export enum AttachmentUploadStatus {
    PENDING_UPLOAD,
    UPLOAD_IN_PROGRESS,
    UPLOAD_FAILED,
    PENDING_RECORD_VALIDATION,
    COMPLETE
}
